(() => {
  const root = document.querySelector('[data-drk-home]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const pushEvent = (eventName, details = {}) => {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({ event: eventName, ...details });
  };

  root.querySelectorAll('[data-vimeo-id]').forEach((button) => {
    button.addEventListener('click', () => {
      const id = button.dataset.vimeoId;
      const name = button.dataset.videoName || id;
      const card = button.closest('[data-drk-video]');
      if (!id || !card || card.dataset.loaded === 'true') return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1&dnt=1&title=0&byline=0&portrait=0&playsinline=1`;
      iframe.title = name === 'philosophy' ? 'Dr. Knot Philosophy video' : 'Dr. Knot 7 Step System video';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('loading', 'eager');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

      card.dataset.loaded = 'true';
      card.replaceChildren(iframe);
      pushEvent('homepage_video_play', { video_name: name, vimeo_id: id, location: 'homepage' });
    }, { once: true });
  });

  root.querySelectorAll('[data-drk-event]').forEach((link) => {
    link.addEventListener('click', () => {
      const eventType = link.dataset.drkEvent;
      const eventMap = {
        primary_cta: 'homepage_primary_cta_click',
        pain_finder: 'homepage_pain_finder_click',
        product_cta: 'homepage_product_cta_click'
      };
      const eventName = eventMap[eventType];
      if (!eventName) return;

      pushEvent(eventName, {
        location: link.dataset.location || '',
        product_path: link.dataset.product || '',
        destination: link.getAttribute('href') || ''
      });
    });
  });

  root.querySelectorAll('[data-drk-pathway]').forEach((link) => {
    link.addEventListener('click', () => {
      pushEvent('homepage_pathway_select', { pathway: link.dataset.drkPathway });
    });
  });
})();
